import { common, custom2, other, text, warning } from 'assets/colors';

export const useStyle = () => ({
  alertTitle: {
    fontSize: '26px !important',
    color: other.error,
  },
  iconStyle: {
    color: other.error,
    fontSize: '65px',
    marginBottom: '150px',
  },
  descriptionTitle: {
    fontSize: '18px !important',
    color: other.error,
  },
  descriptionSubtitle: {
    '&.MuiTypography-root': {
      marginTop: '16px',
      marginBottom: '16px',
    },
    color: common.black,
  },
  dialogStyle: {
    '& .MuiBackdrop-root': {
      backgroundColor: warning.contrastText,
    },
  },
  emailLink: {
    color: custom2.main,
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      color: custom2.main,
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  },
  subtitle2: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    textAlign: 'left',
    color: custom2.main2,
  },
  body: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20.02px',
    letterSpacing: '0.15px',
    // textAlign: 'left',
    color: text.primary,
  },
  caption: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: '18px',
    letterSpacing: '0.15px',
    textAlign: 'left',
  },
  secondaryText: {
    color: text.secondary,
  },
  boldFontWeight: {
    fontWeight: 'bold',
  },
});
